import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";
import RoutesMap from "../../../route_control/RouteControl"

export const dashboardCountTodo = createAsyncThunk('dashboardCount', async ({ navigate, from_date, to_date, location_id }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `dashboard`,
            params: {
                from_date: from_date || undefined,
                to_date: to_date || undefined,
                location_id: location_id || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const dashboardCountSlice = createSlice({
    name: 'dashboardCount',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(dashboardCountTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                const raw = action.payload.data.data || {}
                const kpis = raw.kpis || {}
                state.data = {
                    ...raw,
                    totalAssets: raw.totalAssets ?? kpis.total_assets ?? kpis.totalAssets,
                    correctiveJobOrders: raw.correctiveJobOrders ?? kpis.corrective_open ?? kpis.correctiveJobOrders,
                    completedTasks: raw.completedTasks ?? kpis.completed_tasks ?? kpis.completedTasks,
                    assetsIssued: raw.assetsIssued ?? kpis.assets_issued ?? kpis.assetsIssued,
                    upcomingMaintenance: raw.upcomingMaintenance ?? kpis.upcoming_maintenance ?? kpis.upcomingMaintenance,
                    inventoryLowAlerts: raw.inventoryLowAlerts ?? kpis.low_stock ?? kpis.inventoryLowAlerts,
                    downtimeMetrics: raw.downtimeMetrics ?? kpis.downtime_hours ?? kpis.downtimeMetrics,
                }
            } else if (action?.payload?.status == 401) {
                action?.meta?.arg?.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(dashboardCountTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default dashboardCountSlice.reducer; 